import { Component } from '@angular/core';
import { KeywordsService } from 'src/app/core/services/keywords.service';
import Swal from 'sweetalert2';

 interface Keyword {
    id: number;
    text: string;
    active: boolean;
    createdAt: string;
  }

@Component({
  selector: 'app-blockedfilter',
  templateUrl: './blockedfilter.component.html'
})

export class BlockedFilterComponent {

  inputKeyword = "";
  nextId = 2;
  sortMode = "chronological";
  activeCount = '';
  mostrarModal = false;
  keywordToDelete: Keyword | null = null;
 

  keywords: Keyword[] = [];

  constructor(private keywordsService: KeywordsService) {
  }

  ngOnInit(): void {
    //Leemos el JSON de keywords desde S3 y lo cargamos en el array de keywords
    this.loadKeywords();
  }

  showActiveCount() {
    const activeKeywords = this.keywords.filter(keyword => keyword.active);
    this.activeCount = `Palabras activas: ${activeKeywords.length}`;
  }


  async loadKeywords(): Promise<void> {
    this.keywords = await this.keywordsService.getKeywords();
    this.nextId = this.keywords.length > 0 ? Math.max(...this.keywords.map(k => k.id)) + 1 : 1;
    this.showActiveCount();
  }

  saveKeywords() {
    event.preventDefault();

    const text = this.inputKeyword;
    if (!text) {
      //input.focus();
      return;
    }

    const duplicate = this.keywords.some(
      (inputKeyword) => inputKeyword.text.toLocaleLowerCase("es") === text.toLocaleLowerCase("es")
    );

    if (duplicate) {
      //input.setCustomValidity("Esta palabra ya existe.");
      
      return;
    }

    this.keywords.unshift({
      id: this.nextId++,
      text,
      active: true,
      createdAt: new Date().toISOString()
    });

    this.inputKeyword = "";
    this.showActiveCount();
    this.saveKeywordsInS3(); 
    
    
  };

  

  changeSortMode(mode:string){
    this.sortMode = mode;
    this.sortKeywords(mode as 'chronological' | 'alphabetical');
  }

  sortKeywords(mode: 'chronological' | 'alphabetical'): void {
    if (mode === 'chronological') {
      this.keywords.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() -
          new Date(a.createdAt).getTime()
      );
    } else {
      this.keywords.sort((a, b) =>
        a.text.localeCompare(b.text, 'es', {
          sensitivity: 'base'
        })
      );
    }
  }

  deleteKeyword(id: number): void {
    this.keywords = this.keywords.filter((item) => item.id !== id);
    this.showActiveCount();

    console.log(this.keywords);
    this.saveKeywordsInS3(); 
    
  };

  eliminarKeyword(): void {
    if (!this.keywordToDelete) return;

    const id = this.keywordToDelete.id;

    this.keywords = this.keywords.filter(k => k.id !== id);

    this.mostrarModal = false;
    this.keywordToDelete = null;

    this.saveKeywordsInS3(); 
  }

  saveKeywordsInS3 (): void {
    this.keywordsService.uploadKeywordsS3(this.keywords)
    .subscribe({
      next: (response) => {
        console.log('Keywords guardadas en S3', response);
      },
      error: (error) => {
        console.error('Error al guardar keywords', error);
      }
    });
  }

  confirmarEliminacion(keyword: Keyword): void {
    this.keywordToDelete = keyword;
    this.mostrarModal = true;
  }

  cancelarEliminacion(): void {
    this.mostrarModal = false;
    this.keywordToDelete = null;
  }

  toggleKeyword(keyword: Keyword): void {
    keyword.active = !keyword.active;
    this.showActiveCount();
    this.saveKeywordsInS3(); 
  }

  
  

}
